import { animated, useSpring } from '@react-spring/web';
import React from 'react';
import { useWindowSize } from 'usehooks-ts';
import { Line } from '../../../components/action/Line';
import ButtonApi from '../../../components/ButtonApi';
import ThemedText from '../../../components/theme/ThemedText';
import ThemeLogo from '../../../components/theme/ThemeLogo';
import { useGlobalState } from '../../../state/GlobalStateProvider';

const Submitted = ({ handleClose, handleApplication }) => {
  const [{ user }] = useGlobalState();
  const { width } = useWindowSize();

  function getRandomUser() {
    const TEAM_USERS = ['@pash161', '@krate27', '@devhaikya', '@kyachad', '@khaos_maxxing'];
    const randomIndex = Math.floor(Math.random() * TEAM_USERS.length);
    return TEAM_USERS[randomIndex];
  }

  const springProps = useSpring({
    from: { transform: 'translateX(80%)', opacity: 0 },
    to: { transform: 'translateX(0)', opacity: 1 },
    config: { tension: 150, friction: 30 },
    width: '100%',
    height: '100%',
  });

  function openTweetIntent() {
    const tweetText = encodeURIComponent(`Lmao ${getRandomUser()}, prioritize me in @0xmercle human hub waitlist.`);

    const tweetUrl = `https://twitter.com/intent/tweet?text=${tweetText}`;
    window.open(tweetUrl, '_blank');
  }

  return (
    <animated.div style={springProps} className={'submitted_container'}>
      <div className='close_button' onClick={handleClose}>
        <svg xmlns='http://www.w3.org/2000/svg' width='27' height='26' viewBox='0 0 27 26' fill='none'>
          <g clip-path='url(#clip0_210_11821)'>
            <path d='M13.6279 15.4019L8.18553 20.8443L6.63087 19.2897L13.6279 12.2926L20.625 19.2897L19.0703 20.8443L13.6279 15.4019Z' fill='white' />
            <path d='M13.6221 11.5623L19.0645 6.11987L20.6191 7.67453L13.6221 14.6716L6.625 7.67453L8.17966 6.11987L13.6221 11.5623Z' fill='white' />
          </g>
          <defs>
            <clipPath id='clip0_210_11821'>
              <rect width='25.6552' height='25.6552' fill='white' transform='translate(0.966797 0.223633)' />
            </clipPath>
          </defs>
        </svg>
      </div>
      <svg xmlns='http://www.w3.org/2000/svg' width='114' height='114' viewBox='0 0 114 114' fill='none'>
        <path
          d='M42.5531 7.47734C45.6063 8.48949 48.9668 7.82104 51.4002 5.71753C54.6171 2.93682 59.3868 2.93682 62.6037 5.71753C65.0371 7.82104 68.3976 8.48949 71.4508 7.47734C75.4869 6.13933 79.8936 7.96464 81.8015 11.7647C83.2447 14.6394 86.0936 16.5429 89.3017 16.7762C93.5427 17.0846 96.9154 20.4573 97.2238 24.6983C97.4571 27.9064 99.3606 30.7553 102.235 32.1985C106.035 34.1064 107.861 38.5131 106.523 42.5492C105.511 45.6024 106.179 48.9629 108.282 51.3963C111.063 54.6132 111.063 59.3829 108.282 62.5998C106.179 65.0332 105.511 68.3937 106.523 71.4469C107.861 75.483 106.035 79.8897 102.235 81.7976C99.3606 83.2408 97.4571 86.0897 97.2238 89.2978C96.9154 93.5387 93.5427 96.9115 89.3017 97.2199C86.0936 97.4532 83.2447 99.3567 81.8015 102.231C79.8936 106.031 75.487 107.857 71.4508 106.519C68.3976 105.507 65.0371 106.175 62.6037 108.279C59.3868 111.059 54.6171 111.059 51.4002 108.279C48.9668 106.175 45.6063 105.507 42.5531 106.519C38.517 107.857 34.1103 106.031 32.2024 102.231C30.7592 99.3567 27.9103 97.4532 24.7022 97.2199C20.4613 96.9115 17.0885 93.5387 16.7801 89.2978C16.5468 86.0897 14.6433 83.2408 11.7686 81.7976C7.96854 79.8897 6.14324 75.483 7.48124 71.4469C8.4934 68.3937 7.82495 65.0332 5.72143 62.5998C2.94072 59.3829 2.94072 54.6132 5.72144 51.3963C7.82495 48.9629 8.4934 45.6024 7.48124 42.5492C6.14324 38.5131 7.96854 34.1064 11.7686 32.1985C14.6433 30.7553 16.5468 27.9064 16.7801 24.6983C17.0885 20.4573 20.4613 17.0846 24.7022 16.7762C27.9103 16.5429 30.7592 14.6394 32.2024 11.7647C34.1103 7.96464 38.517 6.13933 42.5531 7.47734Z'
          fill='#7284FF'
          stroke='#314DDF'
          stroke-width='0.56782'
        />
        <g filter='url(#filter0_d_242_4993)'>
          <circle cx='57.0034' cy='56.9978' r='40.5991' fill='#E7EAFF' />
          <circle cx='57.0034' cy='56.9978' r='40.3152' stroke='#314DDF' stroke-width='0.56782' />
        </g>
        <path d='M44.2266 57.2825L52.7465 65.8001L69.7793 48.7649' stroke='#314DDF' stroke-width='3.40692' stroke-linecap='round' stroke-linejoin='round' />
        <defs>
          <filter id='filter0_d_242_4993' x='14.133' y='16.3987' width='85.7398' height='85.7406' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
            <feOffset dy='2.27128' />
            <feGaussianBlur stdDeviation='1.13564' />
            <feComposite in2='hardAlpha' operator='out' />
            <feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
            <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_242_4993' />
            <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_242_4993' result='shape' />
          </filter>
        </defs>
      </svg>
      <div>
        <ThemedText.h3>Application Submitted</ThemedText.h3>
        <ThemedText.p>Welcome aboard! Your portable identity and reputation journey starts now.</ThemedText.p>
      </div>

      <Line />

      <div className='center_text'>
        <ThemedText.h4>Bruh, you think the system's rigged af?</ThemedText.h4>
        <ThemedText.p>Think the selection's just for insiders? </ThemedText.p>
      </div>

      <div>
        <ThemedText.h4>Let’s do a PvP then! 😏</ThemedText.h4>
        <ThemedText.p>
          Ask the Mercle team on X (twitter) to get you into the game, go ahead and tag{' '}
          <a href='https://x.com/pash161' target='_blank'>
            @pash161
          </a>
          ,{' '}
          <a href='https://x.com/krate27' target='_blank'>
            @krate27
          </a>
          ,{' '}
          <a href='https://x.com/devhaikya' target='_blank'>
            @devhaikya
          </a>
          ,{' '}
          <a href='https://x.com/khaos_maxxing' target='_blank'>
            @khaos_maxxing
          </a>
          ,{' '}
          <a href='https://x.com/kyachad' target='_blank'>
            @kyachad
          </a>
          .
        </ThemedText.p>
      </div>

      <button className='share_button' onClick={openTweetIntent}>
        <svg width='30' height='29' viewBox='0 0 30 29' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            d='M29.2218 14.2222C29.2218 22.0769 22.8543 28.4444 14.9996 28.4444C7.14485 28.4444 0.777344 22.0769 0.777344 14.2222C0.777344 6.36751 7.14485 0 14.9996 0C22.8543 0 29.2218 6.36751 29.2218 14.2222Z'
            fill='#111111'
          />
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M13.4585 14.75L9.01384 19.8232H10.9828L14.3848 15.9297L17.3826 19.824L21.2218 19.8031L16.3542 13.3664L20.5081 8.60828L18.5708 8.58662L15.4331 12.1625L12.7486 8.59246L8.77734 8.58815L13.4585 14.75ZM18.8966 18.6554L17.903 18.6523L11.0769 9.71569H12.1456L18.8966 18.6554Z'
            fill='white'
          />
        </svg>
        Ask on Twitter
      </button>

      <ButtonApi onClick={handleApplication}>View Application</ButtonApi>
      {width >= 600 && (
        <>
          <Line />
          <ThemeLogo icon={'mercle'} />
        </>
      )}
    </animated.div>
  );
};

export default Submitted;
